// import React, { useState } from 'react';
import {
  Menu, MenuList, MenuButton, MenuItem, IconButton,
  useDisclosure
} from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { RiFilter2Line, RiFilter2Fill } from "react-icons/ri";

/**
 * フィルター（ドロップダウン）
 * @param filterValue フィルター値
 * @param setFilterValue フィルター値設定関数
 * @param placeholder プレースホルダ
 * @param displayNameFunc 表示名用関数
 * @returns フィルター（テキストボックス）
 */
const FilterDropdown: React.FC<any> = ({ filterValue, setFilterValue, dataSource, propName, displayNameFunc, sortFunc }) => {
  /** 型 */
  type Item = { [key: string]: any };

  /** 翻訳 */
  const { t } = useTranslation();

  /** 状態管理 */
  const { isOpen, onClose, onToggle } = useDisclosure();

  /**
   * 指定したデータのプロパティデータで重複しない値のリストを返す。
   * @param data データ
   * @param propName プロパティ名
   * @returns 重複しないリスト
   */
  const extractUniqueProps = <T extends Item>(data: T[], propName: string): any[] => {
    return [...new Set(data.map(item => item[propName]))];
  }

  /** ドロップダウンリストデータ */
  const drowdownList = sortFunc
    ? extractUniqueProps(dataSource, propName).sort(sortFunc)
    : extractUniqueProps(dataSource, propName);

  return (
    <span style={{ position: 'relative' }}>
      <Menu isOpen={isOpen} onClose={onClose} colorScheme="white" closeOnSelect={true}>
        {/* フィルターアイコン */}
        {filterValue ? <MenuButton as={IconButton} height="16px" icon={<RiFilter2Fill />} onClick={onToggle} /> : <MenuButton as={IconButton} height="16px" icon={<RiFilter2Line />} onClick={onToggle} />}

        {isOpen && (
          <>
            <MenuList boxShadow="md">
              <MenuItem onClick={() => setFilterValue('')}>{t('common.label.all')}</MenuItem>
              {
                drowdownList.map(item => {
                  if (item !== null && item !== undefined && item !== '') {
                    return (
                      <MenuItem key={item}
                        onClick={() => setFilterValue(item)}>{
                          displayNameFunc ? displayNameFunc(item) : item
                        }</MenuItem>
                    );
                  }
                })
              }
            </MenuList>
          </>
        )}
      </Menu>
    </span>
  );
}

export default FilterDropdown;